import { IHostApiService } from "services/models/ApiService";
import {
  IHostTrendingCustomerScore,
  IHostDashboardLayout,
  IHostEvent,
  IHostPlayerTierSumamry,
  IHostPromotion,
  IHostTrip,
  IHostEventDetail,
  IHostPromotionDetail,
} from "services/models/Host";
import { IHostActivePlayer } from "services/models/Host/HostActivePlayer";
import { IHostPlayerAudit } from "services/models/Host/HostGuestAudit";
import { IHostPlayer } from "services/models/Host/HostPlayer";
import { IHostReservation } from "services/models/Host/HostReservation";
import { IAbortablePromise } from "utils";
import { ApiService } from "./ApiService";
import {
  abortableApiNotConnected,
  apiNotConnected,
  authorizedAbortableFetchAsJson,
  authorizedFetchAsJson,
} from "./misc";

export class HostApiService implements IHostApiService {
  constructor(private accessToken: () => Promise<string>) {}

  getDashboardLayout(): Promise<IHostDashboardLayout[]> {
    return apiNotConnected();
  }

  getReservationByStatus(status: string): IAbortablePromise<IHostReservation[]> {
    let urlString = `${ApiService.v1Url}/host/players/reservations/`;
    switch (status) {
      case "active": {
        urlString += "active";
        break;
      }
      case "upcoming": {
        urlString += "upcoming";
        break;
      }
    }
    const url = new URL(urlString);
    return authorizedAbortableFetchAsJson(url, this.accessToken);
  }

  getActivePlayers(): IAbortablePromise<IHostActivePlayer[]> {
    const url = new URL(`${ApiService.v1Url}/host/players/active`);
    return authorizedAbortableFetchAsJson(url, this.accessToken);
  }

  getPlayersBirthday(days?: string): IAbortablePromise<IHostPlayer[]> {
    const url = new URL(`${ApiService.v1Url}/host/players/birthdays${days ? "?inNextDays=" + days : ""}`);
    return authorizedAbortableFetchAsJson(url, this.accessToken);
  }

  getPromotions(): IAbortablePromise<IHostPromotion[]> {
    const url = new URL(`${ApiService.v1Url}/host/players/calendar/promotions`);
    return authorizedAbortableFetchAsJson(url, this.accessToken);
  }

  getPromotion(id: string): Promise<IHostPromotionDetail> {
    const url = new URL(`${ApiService.v1Url}/calendar/promotions/${id}`);
    return authorizedFetchAsJson(url, this.accessToken);
  }

  getEvents(): IAbortablePromise<IHostEvent[]> {
    const url = new URL(`${ApiService.v1Url}/host/players/calendar/events`);
    return authorizedAbortableFetchAsJson(url, this.accessToken);
  }

  getEvent(id: string): Promise<IHostEventDetail> {
    const url = new URL(`${ApiService.v1Url}/calendar/events/${id}`);
    return authorizedFetchAsJson(url, this.accessToken);
  }

  getTrips(type: string): IAbortablePromise<IHostTrip[]> {
    let urlString = `${ApiService.v1Url}/host/players/trips/`;

    switch (type) {
      case "increasing": {
        urlString += "increasing";
        break;
      }
      case "decreasing": {
        urlString += "decreasing";
        break;
      }
    }
    const url = new URL(urlString);
    return authorizedAbortableFetchAsJson(url, this.accessToken);
  }

  getGuestAndHostAudit(): IAbortablePromise<IHostPlayerAudit[]> {
    const url = new URL(`${ApiService.v1Url}/host/audit/players/`);
    return authorizedAbortableFetchAsJson(url, this.accessToken);
  }

  getPlayerTierSummary(): IAbortablePromise<IHostPlayerTierSumamry> {
    const url = new URL(`${ApiService.v1Url}/host/players/tiersummary`);
    return authorizedAbortableFetchAsJson(url, this.accessToken);
  }
  getTrendingCustomerScore(): IAbortablePromise<IHostTrendingCustomerScore[]> {
    const url = `${ApiService.v1Url}/host/players/customerscore/`;
    return authorizedAbortableFetchAsJson(url, this.accessToken);
  }
}
